import api from './request'

const findDeviceMonitorRelationListByPage = ({page, size, relationDto}) => {
    return api.postPromise('monitor/findDeviceMonitorRelationListByPage', {
        page, size
    }, relationDto, null, true)
}


export default {
    findDeviceMonitorRelationListByPage
}



// WEBPACK FOOTER //
// ./src/request/monitorApi.js